import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: 'calc(100% - 350px)',
        height: 'calc(100% - 180px)',
        padding: '15px',
        float: 'left',
        display: 'flex',
        flexDirection: 'column',
    },
    fastEntryContainer: {
        marginBottom: 10,
        backgroundColor: '#ddd'
    },
    gridContainer: {
        width: '100%',
        padding: '0',
        boxSizing: 'border-box',
        height: 'calc(100% - 125px)',
        overflow: 'auto',
        flexGrow: 1
    },
    grid: {
        height: '100%',
        width: '100%'
    },
    lineDetailIcon: {
        cursor: 'pointer'
    },
    disabledIcon: {
        color: '#AAA !important',
    }
});
